import { Box } from "@twilio-paste/core";
import { graphql } from "gatsby";
import { IconQuery } from "queries";
import React from "react";
import { PrimaryLayout } from "../shared/layouts";
import { Container } from "./components/Container";
import { ContentContainer } from "./components/ContentContainer";
import IconDetails from "./iconComponents/IconDetails";
import IconsList from "./iconComponents/IconsList";

export const query = graphql`
    query ($name: String) {
        iconsExamples: allDocsJson(filter: { category: { eq: "Theme / Icons" }, name: { eq: $name } }) {
            nodes {
                examples
                description
                docName
            }
        }
    }
`;
function IconTemplate(props: { data: IconQuery; pageContext: { name: string } }) {
    const result = props.data;
    return (
        <PrimaryLayout>
            <Container>
                <ContentContainer>
                    <Box paddingBottom="space200">
                        <IconDetails sections={result.iconsExamples.nodes} />
                        {props.pageContext.name === "flex-icons" && <IconsList />}
                    </Box>
                </ContentContainer>
            </Container>
        </PrimaryLayout>
    );
}

export default IconTemplate;
